import type { Panel } from '@/types/panels'
import type { BendingMomentCapacitySearchParams, SectionModulusSearchParams } from '@/types/search'

export const searchApi = {
  // Search panels by bending moment capacity
  async searchByBendingMomentCapacity(params: BendingMomentCapacitySearchParams): Promise<Panel[]> {
    const queryParams = new URLSearchParams()
    queryParams.append('bmc', params.bmc.toString())
    if (params.steel_grade) queryParams.append('steel_grade', params.steel_grade.toString())
    if (params.units) queryParams.append('units', params.units)
    if (params.page) queryParams.append('page', params.page.toString())
    if (params.per_page) queryParams.append('per_page', params.per_page.toString())
    if (params.sort) queryParams.append('sort', params.sort)
    if (params.order) queryParams.append('order', params.order)

    const response = await fetch(`/api/search/by_bmc?${queryParams}`)

    if (!response.ok) {
      throw new Error('Failed to search panels by bending moment capacity')
    }

    return response.json()
  },

  // Search panels by section modulus
  async searchBySectionModulus(params: SectionModulusSearchParams): Promise<Panel[]> {
    // Backend returns the weakest few per type in [min_value, max_value], so
    // start at the target: only panels at least as strong are suggested
    const minValue = params.sm
    const maxValue = params.sm * 1.15

    const queryParams = new URLSearchParams()
    queryParams.append('min_value', minValue.toString())
    queryParams.append('max_value', maxValue.toString())
    if (params.units) queryParams.append('units', params.units)
    if (params.page) queryParams.append('page', params.page.toString())
    if (params.per_page) queryParams.append('per_page', params.per_page.toString())
    if (params.sort) queryParams.append('sort', params.sort)
    if (params.order) queryParams.append('order', params.order)

    const response = await fetch(`/api/search/by_sm?${queryParams}`)

    if (!response.ok) {
      throw new Error('Failed to search panels by section modulus')
    }

    return response.json()
  },
}
